import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import styled from 'styled-components';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const StyledDialog = styled(Dialog)`
`;
const Modal = ({open, handleClose, children, maxWidth, fullWidth}) => {

  return (
      <StyledDialog
        open={open}
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{borderRadius: 0, zIndex:5000}}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
        {children}
      </StyledDialog>
  );
}

export default Modal;